<template>
  <nav-bar class="c-navBar" :logout="logout" :user-info="user.profile" />
</template>

<script>
import NavBar from '@/shared/views/nav/navbar';
import { name as userModuleName } from '@/modules/user/store';

import { mapState } from 'vuex';

export default {
  components: {
    NavBar,
  },
  props: {
    userInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState(userModuleName, ['user']),
  },
  data() {
    return {
      selectedStudent: false,
      hasStudentSelected: false,
    };
  },
  methods: {
    logout() {
      this.$emit('logout');
    },
  },
};
</script>

<style scoped lang="scss">
.c-navBar ::v-deep .action-item-notification {
  display: none !important;
}
</style>
